import { getExtensionFromFileName } from './getExtensionFromFileName';
import isImageFile from './isImageFile';
import { isTextFile } from './isTextFile';

export default function getLocalFilePreviewType(
    fileName: string
): 'image' | 'text' | 'pdf' | undefined {
    if (isImageFile(fileName)) {
        return 'image';
    }

    const fileExtension = getExtensionFromFileName(fileName);
    if (
        isTextFile(fileName) ||
        fileExtension === '.csv' ||
        fileExtension === '.json' ||
        fileExtension === '.jsonl' ||
        fileExtension === '.md' ||
        fileExtension === '.tsv'
    ) {
        return 'text';
    }

    if (fileExtension === '.pdf') {
        return 'pdf';
    }

    return undefined;
}
